
export default function CommunityGrowthSection() {
  const features = [
    {
      icon: 'ri-calendar-event-line',
      title: 'Encuentros Semanales',
      badge: 'Flexibles y accesibles',
      description: 'Sesiones diseñadas para personas ocupadas. Cada encuentro es una oportunidad de crecimiento sin presión.',
      color: 'from-green-100 to-green-200',
      iconBg: 'bg-[#6607a5]'
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'Masterclases Exclusivas',
      badge: 'Contenido relevante',
      description: 'Aprende de expertos en temas elegidos por la propia comunidad. Contenido práctico para tu día a día.',
      color: 'from-blue-100 to-blue-200',
      iconBg: 'bg-[#6607a5]'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Espacio de Conexión',
      badge: 'Sin juicios',
      description: 'Comenta, comparte y aprende junto a personas que están en tu misma situación de crecimiento.',
      color: 'from-purple-100 to-purple-200',
      iconBg: 'bg-[#6607a5]'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Recursos Prácticos',
      badge: 'Fácil aplicación',
      description: 'Herramientas simples y efectivas para aplicar en tu rutina diaria sin complicaciones.',
      color: 'from-yellow-100 to-yellow-200',
      iconBg: 'bg-[#6607a5]'
    }
  ];

  const values = [
    {
      title: 'Sin presión',
      subtitle: 'Cada quien a su ritmo',
      icon: 'ri-time-line'
    },
    {
      title: 'Sin juicios',
      subtitle: 'Espacio de aceptación',
      icon: 'ri-shield-check-line'
    },
    {
      title: 'Con apoyo',
      subtitle: 'Comunidad que entiende',
      icon: 'ri-heart-line'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-white to-purple-50">
      <div className="container mx-auto px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-8 tracking-tight">
            Tu 
            <span className="block font-thin bg-gradient-to-r from-[#6607a5] to-purple-600 bg-clip-text text-transparent">
              comunidad de crecimiento
            </span>
          </h2>
          <p className="text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed font-light">
            Un lugar donde puedes ser tú mismo/a, aprender a tu ritmo y conectar con 
            personas que entienden tu proceso.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-32 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 group">
              <div className="flex items-start mb-6">
                <div className={`w-16 h-16 ${feature.iconBg} rounded-2xl flex items-center justify-center mr-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center mb-3">
                    <h3 className="text-xl font-semibold text-gray-900 mr-3">{feature.title}</h3>
                    <span className={`px-3 py-1 rounded-full text-sm font-medium bg-gradient-to-r ${feature.color} text-gray-700`}>
                      {feature.badge}
                    </span>
                  </div>
                </div>
              </div>
              <p className="text-gray-600 font-light leading-relaxed text-lg ml-22">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Safe Space Section */}
        <div className="bg-white rounded-3xl p-12 shadow-xl border border-gray-100 max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <div className="w-20 h-20 bg-gradient-to-br from-[#6607a5] to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-heart-line text-3xl text-white"></i>
            </div>
            <h3 className="text-4xl font-light text-gray-900 mb-6">
              Un espacio seguro para crecer
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed font-light">
              En NEO entendemos que cada persona tiene su ritmo y sus circunstancias. 
              Aquí no hay presión, solo apoyo mutuo y crecimiento auténtico.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-purple-200 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <i className={`${value.icon} text-2xl text-[#6607a5]`}></i>
                </div>
                <h4 className="text-2xl font-semibold text-[#6607a5] mb-2">{value.title}</h4>
                <p className="text-gray-600 font-light">{value.subtitle}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
